import React from 'react'
import { connect } from 'react-redux'
import { Box, Flex } from 'rebass/styled-components'
import loadable from '@loadable/component'
import Spacer from '../components/general/Spacer'

const Columns = ({ options, data }) => {
    const columnContent = []
    Object.entries(options.columns).map(([columnskey, columnsData]) => {
        let column = <Box 
                key={columnskey} 
                width={ (columnsData.width && Array.isArray(columnsData.width)) ? columnsData.width : [columnsData.width || '100%', columnsData.width || '100%', columnsData.width || '100%', columnsData.width || '100%', columnsData.width || '50%']}
            >
                <Spacer spacing={columnsData.spacing}>
                    {
                        Object.entries(columnsData.modules).map(([key, module]) => {
                            const RenderedModule = loadable(props => import(`./${module.module}`))
                            return <RenderedModule key={`col_${columnskey}_${key}`} options={module} data={data} />
                        })
                    }
                </Spacer>
            </Box>
        columnContent.push(column)
        return true
    })

    return (
        <Spacer spacing={options.spacing}>
            <Flex 
                alignItems={options.align || 'flex-start'}
                flexDirection={['column', 'column', 'column', 'column', 'row', 'row', 'row']}
                justifyContent={options.justify || 'center'} 
                variant="container"
            > 
                {columnContent}
            </Flex>
        </Spacer>
    )
}
function mapStateToProps(state) {
    return {}
}

export default connect(mapStateToProps)(Columns)
